import { inject, Pipe, PipeTransform } from '@angular/core';

import { TranslocoService } from '@jsverse/transloco';

import { ArrayUtils } from '@hmax-order/shared/array';
import { Column } from '../../../interfaces';

@Pipe({
  name: 'columnValue',
  standalone: true,
})
export class ColumnValuePipe implements PipeTransform {
  private translocoService = inject(TranslocoService);

  /**
   * Recuperar valor da célula na tabela
   * @param row Dados da linha na tabela
   * @param column dados da coluna na tabela
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transform(row: any, column: Column): any {
    const attribute = column?.name;
    const keys = attribute.split('.');

    let value = row;

    for (const key of keys) {
      if (value && typeof value === 'object' && key in value) {
        if (Array.isArray(value[key]) && ArrayUtils.isStringArray(value[key])) value = this.getStringArrayValue(value[key], column);
        else value = value[key];
      } else {
        return undefined;
      }
    }

    if (typeof value === 'boolean') {
      return value ? 'yes' : '';
    }

    if (typeof value === 'number') {
      return column?.showZero === false && value === 0 ? '' : value;
    }

    return value;
  }

  /**
   * Retornar comma text com cada item do array, traduzidos se
   * o atributo translate for true
   */
  private getStringArrayValue(array: string[], column: Column): string {
    let newArray = [...array];

    if (column?.translate === true) {
      newArray = array.map((value) => {
        return this.translocoService.translate(value);
      });
    }

    return newArray.join(', ');
  }
}
